import { render, staticRenderFns } from "./CreditConfig.vue?vue&type=template&id=04021c81&"
import script from "./CreditConfig.vue?vue&type=script&lang=js&"
export * from "./CreditConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04021c81')) {
      api.createRecord('04021c81', component.options)
    } else {
      api.reload('04021c81', component.options)
    }
    module.hot.accept("./CreditConfig.vue?vue&type=template&id=04021c81&", function () {
      api.rerender('04021c81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/CreditConfig.vue"
export default component.exports